import { useauthMeQuery, useCustomerBillingAddressQuery } from '@/types/generated/graphql';
import { RequestNumberSchema } from '../purchase-number.types';
import { splitName } from '@shared/utils/split-name-v2';
import { DeepPartial } from '@/types/app.types';

export const usePersonalInformation = (): DeepPartial<RequestNumberSchema> => {
  const authMeResult = useauthMeQuery();
  const customerBillingResult = useCustomerBillingAddressQuery();

  const user = authMeResult?.data?.authMe?.data?.user;
  const billingAddress = customerBillingResult?.data?.customerBillingAddress?.data?.billingAddress;

  const nameOfUser = splitName(user?.name);

  return {
    useCase: {
      useCase: 'individual',
      firstName: nameOfUser?.firstName,
      lastName: nameOfUser?.lastName,
      email: user?.email ?? undefined,
      phoneNumber: user?.phoneNumber ?? undefined,
      address: {
        country: billingAddress?.country ?? 'US',
        state: billingAddress?.state ?? undefined,
        zip: billingAddress?.zip ?? undefined,
        suburb: billingAddress?.line1 ?? undefined,
      },
    },
  };
};
